import { useEffect, useState } from "react";
import { playSonicLogo } from "../lib/sound";

const AWAY_MS = 3000;
const isAdmin = () => window.location.pathname.startsWith("/admin");

export default function SplashScreen() {
  const [run, setRun] = useState(() => (isAdmin() ? 0 : 1));
  const [phase, setPhase] = useState(run ? "wait" : "done");

  useEffect(() => {
    let awayAt = 0;
    let lastRun = Date.now();
    let lastTick = Date.now();
    const replay = () => {
      if (isAdmin() || Date.now() - lastRun < AWAY_MS) return;
      lastRun = Date.now();
      setPhase("wait");
      setRun((r) => r + 1);
    };
    const away = () => { if (!awayAt) awayAt = Date.now(); };
    const back = () => {
      if (awayAt && Date.now() - awayAt >= AWAY_MS) replay();
      awayAt = 0;
    };
    const onVis = () => (document.hidden ? away() : back());
    const onShow = (e) => { if (e.persisted) replay(); else back(); };
    const tick = setInterval(() => {
      const now = Date.now();
      if (now - lastTick > AWAY_MS + 1000 && !document.hidden) replay();
      lastTick = now;
    }, 1000);
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("pagehide", away);
    window.addEventListener("pageshow", onShow);
    return () => {
      clearInterval(tick);
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("pagehide", away);
      window.removeEventListener("pageshow", onShow);
    };
  }, []);

  useEffect(() => {
    if (phase === "wait") {
      const t = setTimeout(() => setPhase("leave"), 12000);
      return () => clearTimeout(t);
    }
    if (phase === "leave") {
      const t = setTimeout(() => setPhase("done"), 400);
      return () => clearTimeout(t);
    }
  }, [phase, run]);

  useEffect(() => {
    if (phase !== "play") { return; }
    const stop = playSonicLogo();
    const t1 = setTimeout(() => setPhase("leave"), 2300);
    const t2 = setTimeout(() => { stop(); setPhase("done"); }, 2700);
    return () => { clearTimeout(t1); clearTimeout(t2); stop(); };
  }, [phase]);

  const enter = () => { if (phase === "wait") setPhase("play"); };

  if (phase === "done") return null;
  return (
    <div data-testid="splash-screen" key={run} onClick={enter} role="button" aria-label="Tap to enter MLOBOX"
      className={`fixed inset-0 z-[9999] bg-[#111111] grid place-items-center cursor-pointer transition-opacity duration-300 ${phase === "leave" ? "opacity-0 pointer-events-none" : "opacity-100"}`}>
      <div className="flex flex-col items-center">
        <div className="relative h-36 w-36 sm:h-44 sm:w-44">
          <div className="absolute inset-0 rounded-full bg-[#FF6600]/30 blur-2xl splash-pulse" />
          <img key={phase === "wait" ? "a" : "b"} src="/logo.png" alt="MLOBOX" data-testid="splash-logo" fetchpriority="high"
            className="relative h-full w-full rounded-[28%] splash-spin" />
        </div>
        <div className="mt-8 font-display text-white font-extrabold text-2xl tracking-[0.3em] splash-rise">MLOBOX</div>
        <div className="mt-2 text-[#FF8A3D] text-xs font-semibold tracking-[0.25em] splash-rise" style={{ animationDelay: "0.25s" }}>
          TASTE THE COMFORT OF HOME
        </div>
        <div data-testid="splash-tap-hint"
          className={`mt-10 rounded-full border border-white/25 px-5 py-2 text-white/80 text-[11px] font-semibold tracking-[0.3em] ${phase === "wait" ? "splash-tap" : "opacity-0"}`}>
          TAP TO ENTER
        </div>
      </div>
    </div>
  );
}
